import { render, staticRenderFns } from "./AcoesList.vue?vue&type=template&id=525d13b2"
import script from "./AcoesList.vue?vue&type=script&lang=js"
export * from "./AcoesList.vue?vue&type=script&lang=js"
import style0 from "./AcoesList.vue?vue&type=style&index=0&id=525d13b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports